import React from 'react';
import styles from './ExerciseCardTopBar.module.css';

interface ExerciseCardTopBarProps {
  label: string;
  color?: string;
  textColor?: string;
}

const ExerciseCardTopBar: React.FC<ExerciseCardTopBarProps> = ({ label, color, textColor }) => (
  <div
    className={styles.exerciseCardTopBar}
    style={color || textColor ? {
      ...(color ? { backgroundColor: color } : {}),
      ...(textColor ? { color: textColor, WebkitTextFillColor: textColor } : {}),
    } : undefined}
    title={label}
  >
    {label}
  </div>
);

export default ExerciseCardTopBar;
